var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../../lib/interactjs/dist/interact", "../LayoutDesigner/LayoutElement"], function (require, exports, interact, LayoutElement_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfigurationContainerElement = (function (_super) {
        __extends(ConfigurationContainerElement, _super);
        function ConfigurationContainerElement(width, height, x, y, id, parent, layout) {
            if (layout === void 0) { layout = null; }
            var _this = _super.call(this, width, height, x, y, id, parent, layout) || this;
            _this.isEditable = true;
            _this.jqHeaderElement = _this.element.children('[data-type="header"]').first();
            _this.deleteButton = $('<button class="EditContentButton"><span class="k-icon k-i-delete"></span></button>');
            _this.jqHeaderElement.append(_this.deleteButton);
            interact(_this.deleteButton.first().get(0)).on('tap', _this.OnDeleteClicked.bind(_this));
            _this.ClassName = "ConfigContainerRect";
            return _this;
        }
        Object.defineProperty(ConfigurationContainerElement.prototype, "IsEditable", {
            get: function () { return this.isEditable; },
            set: function (value) {
                this.isEditable = value;
            },
            enumerable: true,
            configurable: true
        });
        ConfigurationContainerElement.prototype.OnDeleteClicked = function () {
            this.FireEvent("DeleteContainerElement", { element: this });
        };
        ConfigurationContainerElement.prototype.AddInactiveLayer = function () {
            this.element.prepend('<div class="InactiveLayer" style="height:calc(100% - 30px); top:30px"></div>');
        };
        ConfigurationContainerElement.prototype.AddNameFromObject = function () {
            if (this.object != null) {
                var content = this.object;
                if (content.Name !== undefined) {
                    this.headlineDiv = $('<div class="SujetName">Sujet: ' + content.Name + '</div>');
                    this.jqHeaderElement.append(this.headlineDiv);
                }
            }
        };
        return ConfigurationContainerElement;
    }(LayoutElement_1.LayoutElement));
    exports.ConfigurationContainerElement = ConfigurationContainerElement;
});
//# sourceMappingURL=ConfigurationContainerElement.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/ConfigurationDesigner/ConfigurationContainerElement.js
// module id = 389
// module chunks = 0